import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMealRepository} from '../ports/saved-meal.repository';

export class ClearRecentLineIngredients implements UseCase<[], void> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(): Promise<Result<void, SavedMealError>> {
    return this.repository.clearRecentLineIngredients();
  }
}
